import React, { useState, useRef } from "react";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { bodyContentMapper } from "components/studio/board/nodes/Node.lib";
import { Button, Overlay, Popover } from "react-bootstrap";
import MiniBoard from "components/vmisc/flow_preview/MiniBoard";
import { ColumnTypeLabels } from "components/collections/util/datatypes";
import l from "components/util/l";


const CategoryHeader = ({ value }) => {
  if (value != "collection" && value != "variable" && value != "constant")
    return <div></div>

  return <span className="d-flex justify-content-between dropdown-header pt-2 px-3">
    <span style={{ color: "#aaa", fontSize: "0.8em" }}>
      {value == "collection" ? "Tablas" : ""}
      {value == "variable" ? "Referencias" : ""}
      {value == "constant" ? "Constantes" : ""}
    </span>
  </span>
}

const ConstantItem = ({ constant, disabled, isOnSelector = false }) => (
  <div className="d-flex align-items-center pl-1 pr-4 py-2"
    style={{
      pointerEvents: "none",
      color: "#777", fontSize: "1rem",
      ...isOnSelector ? { position: "absolute", marginTop: "-2.55rem", marginLeft: "1rem", background: disabled ? "#f8fafd" : "#fff" } : {}
    }}>
    <i className="fas fa-hashtag mr-3" style={{ color: "#888" }}></i>
    <span style={{ color: "#606a70", fontSize: "0.9em" }}>
      {constant?.label}
    </span>
  </div>
)

const CollectionItem = ({ collection, disabled, isOnSelector = false }) =>
  <div className="d-flex align-items-center pl-1 pr-4 py-2"
    style={{
      pointerEvents: "none",
      color: "#777", fontSize: "1rem",
      ...isOnSelector ? { position: "absolute", marginTop: "-2.55rem", marginLeft: "1rem", background: disabled ? "#f8fafd" : "#fff" } : {}
    }}>
    <i className="fas fa-table mr-3" style={{ color: "#888" }}></i>
    <span style={{ color: "#606a70", fontSize: "0.9em" }}>
      {collection?.uiSettings?.label ? collection?.uiSettings?.label : collection?.name.substring(1)}
    </span>
  </div>


const AddCollectionItem = ({ onClickAddCollection }) =>
  <div className="d-flex align-items-center px-1 py-2 w-100"
    onClick={onClickAddCollection}
    style={{ color: "#777", fontSize: "1rem" }}>
    <i className="fas fa-plus mr-3" style={{ color: "#888" }}></i>
    <span style={{ color: "#777", fontSize: "0.9em" }}><i>Crear tabla</i></span>
  </div>


const AddNodeItem = ({ onClickAddNode }) =>
  <div className="d-flex align-items-center px-1 py-2 w-100"
    onClick={onClickAddNode}
    style={{ color: "#777", fontSize: "1rem" }}>
    <i className="fas fa-plus mr-3" style={{ color: "#888" }}></i>
    <span style={{ color: "#777", fontSize: "0.9em" }}><i>Crear acción</i></span>
  </div>


const VariableItem = ({ node, disabled, isOnSelector = false }) => {

  const title = node.action.uiSettings?.node?.title ?? node.action.uiSettings?.general?.title;
  const icon = node.action.app.uiSettings?.icon ?? "fas fa-project-diagram"
  const subtitle = bodyContentMapper(node.action.uiSettings?.node ?? [], node.input, "subtitle", [])
  const numOutput = node.output_count > 1

  return (
    <div className="d-flex align-items-center pl-1 pr-1"
      style={{
        pointerEvents: "none",
        color: "#777", fontSize: "1rem",
        ...isOnSelector ? { position: "absolute", marginTop: "-2.55rem", marginLeft: "1rem", background: disabled ? "#f8fafd" : "#fff" } : {}
      }}>
      <i className={icon + " mr-3"} style={{ color: "#888" }}></i>
      <div className="mt-2 ml-1">
        <span className="text-truncate d-inline-block"
          style={{ color: "#606a70", fontSize: "0.9em", maxWidth: subtitle != "" ? "12rem" : "25rem" }}>
          {title}
        </span>
        {subtitle != "" ?
          <span className="ml-2 text-truncate d-inline-block"
            style={{ color: "#aaa", fontSize: "0.8em", maxWidth: "17rem" }}>({subtitle})</span> : null
        }
        {numOutput > 1 ?
          <span className="ml-1"
            style={{ color: "#b0b0b0", fontSize: "0.75em" }}>({node.label ?? node.name})</span> : null
        }
      </div>

    </div>
  )
}

const AttributeItem = ({ label, disabled, isOnSelector = false }) =>
  <div className="d-flex align-items-center pl-1 pr-4 py-2"
    style={{
      pointerEvents: "none",
      color: "#777", fontSize: "1rem",
      ...isOnSelector ? { position: "absolute", marginTop: "-2.55rem", marginLeft: "0.85rem", background: disabled ? "#f8fafd" : "#fff" } : {}
    }}>
    <span className="text-truncate" style={{ color: "#6a7075", fontSize: "0.85em", maxWidth: "24rem" }}>
      <span style={{ marginRight: "0.65rem" }}>-</span>
      <span>{label}</span>
    </span>
  </div>

const OutputCollectionDescription = ({ collection }) => {
  const [overlayShown, setOverlayShown] = useState(false)
  const schema = collection?.schema?.structure ?? [];

  return (
    <OverlayTrigger key="top" trigger="click" placement={"top"} delay={0} className="p-0"
      onToggle={(nextShow) => { setOverlayShown(nextShow) }}
      overlay={
        <Popover id={`help-message-collection-popover-${collection.id}`} className="popover-help-message-collection p-0">
          <Popover.Body className="p-0">
            <div className="popover-collection-help-message-content">
              <h5 className="text-center">{collection?.uiSettings?.label ?? collection?.name}</h5>
              <ul>
                {schema.map((column) => {
                  if (column.internal == true) return <></>
                  return (
                    <li key={column.name}>
                      <strong>{column.label ?? column.name}:</strong> {l(ColumnTypeLabels[column.type] ?? column.type)}
                    </li>
                  )
                })}
              </ul>
            </div>
          </Popover.Body>
        </Popover>
      }>
      <div
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOverlayShown(!overlayShown) }}>
        <i class={"far fa-eye p-2"}
          style={{ color: !overlayShown ? "#c0c5d0" : "#2080e5", cursor: "pointer", marginTop: "0.25rem" }}></i>
      </div>
    </OverlayTrigger>
  );
}

const OutputDescription = ({ node, flowId }) => {
  const [overlayShown, setOverlayShown] = useState(false)
  const inputStructure = node?.action?.inputStructure ?? [];
  const inputFields = node?.action?.uiSettings?.form?.fields ?? [];
  const inputValues = node?.input ?? [];

  const showField = (field) => {
    const showConditions = field.show_if;
    if (!showConditions) {
      return true;
    }
    let showInput = true;
    for (const conditional of showConditions) {
      const variable = conditional?.variable ?? "";
      const value = conditional?.value ?? "";
      const condition = conditional?.condition ?? "EQUAL";
      const inputValue = inputValues.find(v => v.name === variable)?.value;

      switch (condition) {
        case "EQUAL":
          if (!(inputValue == value)) showInput = false;
          break;

        case "NOT_EQUAL":
          if (!(inputValue != value)) showInput = false;
          break;

        case "GRATER_THAN":
          if (!(inputValue > value)) showInput = false;
          break;

        case "LOWER_THAN":
          if (!(inputValue < value)) showInput = false;
          break;

        case "GRATER_THAN_OR_EQUAL":
          if (!(inputValue >= value)) showInput = false;
          break;

        case "LOWER_THAN_OR_EQUAL":
          if (!(inputValue <= value)) showInput = false;
          break;

        case "CONTAINS":
          if (!(inputValue.includes(value))) showInput = false;
          break;

        default:
          break;
      }

    }
    return showInput;
  }

  return (
    <OverlayTrigger key="top" trigger="click" placement={"top"} delay={0} className="p-0"
      onToggle={(nextShow) => { setOverlayShown(nextShow) }}
      overlay={
        <Popover id={`help-message-popover-${node.id}`} className="popover-help-message p-0">
          <Popover.Body className="p-0">
            <div className="d-flex popover-help-mini-board-container">
              <div className="popver-help-message-content">
                <h5>{node?.action?.uiSettings?.node?.title ?? node?.action?.uiSettings?.general?.title}</h5>
                <ul>
                  {inputStructure.map((input) => {
                    const field = inputFields.find(f => f.name === input.name) ?? {}
                    const value = inputValues.find(v => v.name === input.name)?.value
                    const stringTypes = ["int", "string", "date", "boolean", "float", "text"]
                    if (stringTypes.includes(input.type) && showField(field)) {
                      return (
                        <li key={input.name}>
                          <strong>{field?.label ?? input.name}:</strong> {value ? value.toString() : "<vacío>"}
                        </li>
                      )
                    }
                    return <></>
                  })}
                </ul>
              </div>

              <div className="popover-mini-board">
                <MiniBoard
                  flowId={flowId}
                  focusedNodeId={node.id}
                />
              </div>
            </div>
          </Popover.Body>
        </Popover>
      }>
      <div
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOverlayShown(!overlayShown) }}>
        <i class={"far fa-eye p-2"}
          style={{ color: !overlayShown ? "#c0c5d0" : "#2080e5", cursor: "pointer", marginTop: "0.25rem" }}></i>
      </div>
    </OverlayTrigger>
  )
}

export {
  CategoryHeader, CollectionItem, AddCollectionItem, AddNodeItem, VariableItem,
  AttributeItem, ConstantItem, OutputDescription, OutputCollectionDescription
};